import { createAccountingModeGuard, billClientChangeErrorMessage } from '@/modules/matters/accountingModeGuard';
import { computeTrustDisplay } from '@/modules/matters/matterBillingRules';
angular.module('leanlaw').controller('MatterBillingCtrl', ['$scope', '$rootScope', '$window', '$timeout', 'leanLawApi', '$state', 'userService', 'matterManager', 'accountingService', 'lists', 'alerts', 'utils', function ($scope, $rootScope, $window, $timeout, leanLawApi, $state, userService, matterManager, accountingService, lists, alerts, utils) {
  $scope.newUser = {};
  $scope.accounting = {
    connected: false
  };
  $scope.lists = lists;
  $scope.contact = {};
  $scope.billClientValue = null;
  $scope.deliveryValue = '';
  $scope.multipleEmailPattern = utils.emailRegexPattern;

  // V4 Story 5: blocks an accounting-mode change once a contingent matter's
  // settlement is past Step 1. Shared with the QuickBooks Connector modal,
  // the other write path to this setting (sc-47290).
  const accountingModeGuard = createAccountingModeGuard();
  let destroyed = false; // a late resolution must not write through a dead $scope
  let unsavedTimeout = null; // the "unsaved changes" banner's auto-dismiss
  // Assigned below, but declared here so $destroy never depends on having
  // reached that line — activate() runs in between and can throw.
  let deactivate = null;
  $scope.$on('$destroy', () => {
    destroyed = true;
    // $rootScope outlives this controller, so its listener has to be
    // released here or it keeps the whole controller closure — including
    // the mounted dialog app and its host — alive for the session.
    // Deregistration is idempotent, so a prior call is harmless.
    if (deactivate) {
      deactivate();
      deactivate = null;
    }
    if (unsavedTimeout) {
      $timeout.cancel(unsavedTimeout);
      unsavedTimeout = null;
    }
    accountingModeGuard.destroy();
  });

  // Function to check if form has email validation errors
  $scope.hasEmailValidationErrors = function () {
    if (!$scope.overrideEmail) return false;
    return $scope.billingForm && ($scope.billingForm.emailTo.$error.pattern || $scope.billingForm.emailCC.$error.pattern);
  };
  activate();

  // The unsaved-changes guard lives exactly as long as the controller:
  // registered here, deregistered in $destroy. It used to deregister itself
  // from inside its own handler, which also switched it off while the
  // controller was still alive — matter.billing has child states
  // (.connect, .trust), and entering one fires $stateChangeStart without
  // destroying this controller, so the first such navigation removed the
  // warning for the rest of the visit.
  deactivate = $rootScope.$on('$stateChangeStart', event => {
    if ($scope.billingForm.$dirty) {
      $scope.unsaved = true;
      unsavedTimeout = $timeout(() => {
        $scope.unsaved = false;
      }, 4000);
      event.preventDefault();
    }
  });
  $scope.save = function () {
    $scope.saving = true;
    $scope.error = null;

    // Validate emails if override is enabled
    if ($scope.overrideEmail) {
      if ($scope.email && !utils.isValidEmail($scope.email)) {
        alerts.error("Please enter valid email addresses in the 'Email To' field");
        $scope.saving = false;
        return;
      }
      if ($scope.emailCC && !utils.isValidEmail($scope.emailCC)) {
        alerts.error("Please enter valid email addresses in the 'Email CC' field");
        $scope.saving = false;
        return;
      }
    }
    $scope.matter.custom = $scope.matter.custom || {};
    $scope.matter.custom.email = $scope.overrideEmail ? $scope.email : "";
    $scope.matter.custom.emailCC = $scope.overrideEmail ? $scope.emailCC : "";
    $scope.matter.contact = $scope.overrideAddress ? $scope.contact : {};
    $scope.matter.update().then(matter => {
      $scope.saving = false;
      $scope.billingForm.$setPristine();
      $scope.assignMatterToScope(matter);
    }).catch(err => {
      $scope.saving = false;
      alerts.error(err);
    });
  };
  $scope.cancel = function () {
    $scope.error = false;
    $scope.matter.reload().then(matter => {
      $scope.billingForm.$setPristine();
      $scope.assignMatterToScope(matter);
    });
  };
  $scope.quickbooks = function () {
    accountingService.verify(true).then(() => {
      $state.go(".connect", {
        matterId: $scope.matter.id
      });
    });
  };
  $scope.viewInQuickBooks = function (account) {
    const url = `${$scope.me.configuration.quickbooks}/app/customerdetail?nameId=${account.id}`;
    $window.open(url);
  };
  $scope.changeEmail = function () {
    if ($scope.overrideEmail) {
      $scope.email = $scope.matter.custom.email;
      $scope.emailCC = $scope.matter.custom.emailCC;
    } else {
      $scope.email = $scope.matter.client.email;
      $scope.emailCC = $scope.matter.client.emailCC;
    }
  };
  $scope.updateEvergreen = function () {
    let update = null;
    $scope.billing.evergreen = $scope.evergreen || 0;
    if ($scope.matter.client.billing.billClient) {
      update = leanLawApi.updateClient({
        id: $scope.matter.client.id,
        body: {
          billing: $scope.billing
        }
      });
    } else {
      update = leanLawApi.updateMatter({
        id: $scope.matter.id,
        body: {
          billing: $scope.billing
        }
      });
    }
    update.then(info => {
      $scope.billing = info.billing;
    }).catch(err => {
      alerts.error(err);
    });
  };
  $scope.changeAddress = function () {
    if ($scope.overrideAddress) {
      $scope.contact = angular.copy($scope.matter.contact);
      $scope.showMatterLabel = false;
    } else {
      $scope.contact = angular.copy($scope.matter.client.contact);
      $scope.showMatterLabel = $scope.me.company.settings.matterBillingAddress;
    }
  };
  $scope.deliveryChange = value => {
    if (value === 'email') {
      // must have valid email address or invoice processing will fail
      const clientContact = $scope.matter.client.contact;
      const hasEmail = clientContact && clientContact.email || $scope.matter.contact && $scope.matter.contact.email;
      if (!hasEmail) {
        return alerts.error("You must specify an email for the client in order to pick email delivery.");
      }
    }
    $scope.deliverySaving = true;
    return leanLawApi.updateAccountingClient({
      id: $scope.accountingClient.id,
      body: {
        invoiceDelivery: value
      }
    }).then(updated => {
      $scope.accountingClient = updated;
    }).catch(alerts.error).finally(() => {
      $scope.deliverySaving = false;
    });
  };
  $scope.salesTermChange = () => {
    $scope.termsSaving = true;
    return leanLawApi.updateAccountingClient({
      id: $scope.accountingClient.id,
      body: {
        salesTerm: $scope.accountingClient.salesTerm || {}
      }
    }).then(updated => {
      $scope.accountingClient = updated;
    }).catch(alerts.error).finally(() => {
      $scope.termsSaving = false;
    });
  };
  $scope.billClientChange = function (value) {
    const features = $scope.me?.features || {};
    const context = {
      value,
      billClientValue: $scope.billClientValue,
      clientId: $scope.matter.client?.id,
      settlementEnabled: !!features.settlementTab,
      clientAccountingEnabled: !!features.settlementClientAccounting,
      matterTerm: $scope.me?.terms?.Matter || 'Matter'
    };
    accountingModeGuard.check(context).then(allowed => {
      // Guarded: a reset can resolve after the user has navigated away, and
      // applying the change then would write through a dead $scope.
      if (destroyed || !allowed) return;
      performBillClientChange(value);
    }).catch(err => {
      if (destroyed) return;
      // Never hand the raw rejection to alerts.error — see billClientChangeErrorMessage.
      alerts.error(billClientChangeErrorMessage(err));
    });
  };
  function performBillClientChange(value) {
    const billing = angular.copy($scope.matter.client.billing);
    billing.billClient = value;
    billing.invoiceDelivery = $scope.invoiceDeliveryValue;
    if (!$scope.matter.client.accounting) {
      return leanLawApi.updateClient({
        id: $scope.matter.client.id,
        body: {
          billing
        }
      }).then(client => {
        $scope.matter.client = client;
        $scope.billClientValue = value;
      });
    }
    let msg = `<p>You are changing the way this client and ${$scope.me.terms.matter} are mapped in QuickBooks, which impacts how invoices are billed and how trust accounting is handled.</p>`;
    msg += `<p>Any paid invoices and payments in QuickBooks do not have to be moved, but this will NOT reassign them.</p>`;
    msg += `<p>Any unpaid or partially paid invoices in LeanLaw, belonging to this ${$scope.me.terms.matter} or other ${$scope.me.terms.matter}s sharing the same client, must be moved back to Drafts.</p>`;
    const buttons = {
      cancel: {
        label: "Cancel",
        className: 'btn'
      },
      ok: {
        label: "Change",
        className: 'btn-success',
        callback() {
          updateClientBilling(billing, false);
        }
      }
    };
    if (value == true) {
      msg += `<p>Any ${$scope.me.terms.matter}s already in QuickBooks will stay there, and would have to be removed manually.</p>`;
    } else {
      msg += `<p>Pick '<b>Change</b>' to change it to ${$scope.me.terms.Matter} Accounting and try to match existing sub-customers in QuickBooks to the ${$scope.me.terms.matter}s. Any matters not matched will have to be connected manually.</p>`;
      msg += `<p>Pick '<b>Change and Create ...</b>' to create ${$scope.me.terms.matter}s in QuickBooks that don't already exist.</p>`;
      buttons.add = {
        label: `Change and Create ${$scope.me.terms.Matter}s in QuickBooks`,
        className: 'btn-success',
        callback() {
          updateClientBilling(billing, true);
        }
      };
    }
    bootbox.dialog({
      title: "Client Accounting Change",
      message: msg,
      buttons
    });
  }
  function updateClientBilling(billing, createMatters) {
    $scope.updating = true;
    return leanLawApi.updateClientBilling({
      id: $scope.matter.client.id,
      body: {
        billing,
        createMatters
      }
    }).then(client => matterManager.get($scope.matter.id).then(matter => {
      $scope.matter = matter;
      $scope.billClientValue = matter.client.billing.billClient;
      refreshAccountingDisplay(matter);
    })).catch(err => {
      alerts.error(err);
    }).finally(() => {
      $scope.updating = false;
    });
  }

  ///////////////////////////////////

  function activate() {
    userService.me().then(me => {
      $scope.me = me;
    });

    // Registered unconditionally: a verify() timeout used to leave this
    // watch never registered at all, so $scope.trust stayed whatever it
    // was on a fresh controller (undefined) instead of ever being
    // computed as "not connected". accounting.connected starts false, so
    // refreshAccountingDisplay already renders the correct not-connected
    // state on this first pass.
    $scope.$watch('matter', matter => {
      if (!matter.billing) return;
      if (!matter.access.billing || matter.billing.type == 'internal') {
        return $state.go('^.info');
      }
      $scope.billClientValue = matter.client.billing.billClient;
      if (typeof $scope.billClientValue === 'undefined') {
        if (matter.accounting && matter.accounting.id) {
          $scope.billClientValue = false;
        } else {
          $scope.billClientValue = $scope.me.company.settings.clientBilling && $scope.me.company.settings.clientBilling.billClient;
        }
      }
      refreshAccountingDisplay(matter);
      if (matter.contact) {
        $scope.contact = angular.copy(matter.contact);
        $scope.showMatterLabel = false;
        $scope.overrideAddress = true;
      } else {
        $scope.contact = angular.copy(matter.client.contact);
        $scope.showMatterLabel = $scope.me.company.settings.matterBillingAddress;
        $scope.overrideAddress = false;
      }
      if (matter.custom.email) {
        $scope.email = matter.custom.email;
        $scope.emailCC = matter.custom.emailCC;
        $scope.overrideEmail = true;
      } else {
        $scope.email = matter.client.email;
        $scope.emailCC = matter.client.emailCC;
        $scope.overrideEmail = false;
      }
    });
    accountingService.verify().then(() => {
      $scope.accounting.connected = true;
      refreshAccountingDisplay($scope.matter);
    }).catch(() => {
      // Explicit, rather than just skipping the watch registration: a
      // timeout is not "connected", and refreshAccountingDisplay needs to
      // re-run now in case the matter watch already fired while this was
      // still pending (matter's $watch reference won't fire again on its
      // own to pick up the flag flipping).
      $scope.accounting.connected = false;
      refreshAccountingDisplay($scope.matter);
    });
  }

  // Recomputes everything downstream of matter + accounting-connected
  // state. Called from the matter $watch, from updateClientBilling (whose
  // matterManager.get() re-fetch returns the SAME cached matter instance,
  // so the $watch reference never re-fires — sc-46818 mechanism (a)), and
  // from verify()'s resolution/rejection so a slow QuickBooks connection
  // doesn't leave this stuck at its pre-connectivity state.
  function refreshAccountingDisplay(matter) {
    // Guards the two call sites reachable from verify()'s own callback,
    // which can settle before $scope.matter exists or before userService
    // .me() has resolved — the $watch callback already implies both.
    if (!matter || !matter.billing || !$scope.me) return;
    if ($scope.accounting.connected) {
      loadAccounting(matter);
      leanLawApi.listAccountingTerms().then(list => {
        $scope.salesTermOptions = list.terms;
      });
    }
    const {
      trust,
      showFixTrustBanner
    } = computeTrustDisplay({
      billClient: !!matter.client.billing.billClient,
      matterTrust: matter.billing.trust,
      clientTrust: matter.client.billing.trust,
      trustEnabled: !!$scope.me.company.settings.trustEnabled,
      accountingConnected: !!$scope.accounting.connected
    });
    $scope.billing = matter.client.billing.billClient ? matter.client.billing : matter.billing;
    $scope.trust = trust;
    $scope.showFixTrustBanner = showFixTrustBanner;
    if (trust) {
      $scope.showEvergreen = $scope.me.company.settings.trust.evergreen;
      const {
        accounts
      } = $scope.me.company.settings.trust;
      const account = accounts.find(a => a.id == trust.id);
      trust.label = account ? account.label : accounts.length ? accounts[0].label : 'Trust Account';
      $scope.evergreen = $scope.billing.evergreen;
      leanLawApi.getAccountingAccount({
        id: trust.account.id
      }).then(a => {
        $scope.trustAccount = a;
      });
    } else {
      $scope.showEvergreen = false;
      $scope.trustAccount = null;
    }
  }
  function loadAccounting(matter) {
    if (matter.client.billing.billClient) {
      if (matter.client.accounting) {
        accountingService.getClient(matter.client.accounting.id).then(client => {
          $scope.accountingClient = client;
        });
      }
    } else if (matter.accounting) {
      accountingService.getClient(matter.accounting.id).then(client => {
        $scope.accountingClient = client;
      });
    }
  }
}]);